import React from 'react';
import { ShortBody, LongBody } from 'components/Typography';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

export const StyledBox = styled(({ isRadiusTop, isBgColor, ...otherProps }) => (
  <Box {...otherProps} />
))`
  border: 1px solid #e3e3e3;
  border-radius: ${(props) =>
    props.isRadiusTop ? '10px 10px 0px 0px' : '0px 0px 10px 10px'};
  border-top: ${(props) => (props.isRadiusTop ? '1px solid #e3e3e3' : 'none')};
  background-color: ${(props) => (props.isBgColor ? '#f5f5f5' : 'unset')};
`;

export const StyledImg = styled.img`
  float: right;
  width: 32px;
  height: 31px;
`;

export const StyledShortBody = styled(({ MarginBottom, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  line-height: 24px !important;
  margin-bottom: ${(props) => props.MarginBottom} !important;
`;
export const StyledLongBody = styled(LongBody)`
  line-height: 24px !important;
  text-align: end;
`;
